import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useEvent from '@src/hooks/useEvent';
import { TAB_OFFLINE_EVENT_INTRODUCTION } from '@src/const/event';

import HtmlParser from '@src/components/common/htmlParser';
import Header from '@src/components/common/header';
import { BlockWrapper } from '@src/components/common/commonStyle';

const StyledBlockWrapper = styled(BlockWrapper)`
	margin-top: 4px;
`;

const Introduction = (): JSX.Element => {
	const { t } = useTranslation();
	const { event: { detail } } = useEvent();

	return (
		<StyledBlockWrapper id={TAB_OFFLINE_EVENT_INTRODUCTION}>
			<Header text={t(`event:${TAB_OFFLINE_EVENT_INTRODUCTION}`)} />
			<HtmlParser html={detail} isCourse />
		</StyledBlockWrapper>
	);
};

export default Introduction;
